import { render, staticRenderFns } from "./customSpecificationDialog.vue?vue&type=template&id=6951a876"
import script from "./customSpecificationDialog.vue?vue&type=script&lang=js"
export * from "./customSpecificationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports